import { useState, useEffect } from 'react';

/**
 * Hook to determine button size based on window width
 * @param breakpoint - Window width breakpoint in pixels (default: 768)
 * @returns Button size: 'medium' for screens below breakpoint, 'large' for screens above
 */
export function useResponsiveButtonSize(breakpoint = 768) {
  const [buttonSize, setButtonSize] = useState<'medium' | 'large'>(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth < breakpoint ? 'medium' : 'large';
    }
    return 'large';
  });

  useEffect(() => {
    const updateButtonSize = () => {
      setButtonSize(window.innerWidth < breakpoint ? 'medium' : 'large');
    };

    updateButtonSize();
    window.addEventListener('resize', updateButtonSize);
    return () => window.removeEventListener('resize', updateButtonSize);
  }, [breakpoint]);

  return buttonSize;
}
